/* eslint-disable react-refresh/only-export-components */
import AdicionarCertificado from '@/templates/Admin/Certificados/modals/Adicionar'
import ExcluirCertificado from '@/templates/Admin/Certificados/modals/Excluir'
import AdicionarPlano from '@/templates/Admin/PlanosPrecos/modals/Adicionar'
import EditarPlano from '@/templates/Admin/PlanosPrecos/modals/Editar'
import ExcluirPlano from '@/templates/Admin/PlanosPrecos/modals/Excluir'
import ImportarPlano from '@/templates/Admin/PlanosPrecos/modals/Importar'
import React from 'react'
import {
    Outlet,
    RouteObject,
    useOutletContext,
    useSearchParams,
} from 'react-router-dom'
import { Cliente, clientes as clientesApi } from 'service/api'
import { PaginatedResponse } from 'service/api/types'
import AdminAlterarSenha from 'templates/Admin/Clientes/atoms/AlterarSenha'
import AdicionarClientes from 'templates/Admin/Clientes/modals/Adicionar'
import { DetalhesRegistro } from 'templates/ManutencaoDoPonto/Digitacao/modals/DetalhesRegistros'
import EditarCliente from 'templates/Admin/Clientes/modals/Editar'
import FinanceiroCliente from 'templates/Admin/Clientes/modals/Financeiro'
import AdicionarTreinamento from 'templates/Admin/Clientes/modals/Treinamentos/Adicionar'
import EditarTreinamento from 'templates/Admin/Clientes/modals/Treinamentos/Editar'
import ExcluirTreinamento from 'templates/Admin/Clientes/modals/Treinamentos/Excluir'
import AdicionarUsuario from 'templates/Admin/Usuarios/modals/Adicionar'
import EditarUsuario from 'templates/Admin/Usuarios/modals/Editar'
import DetalhesEmpresa from 'templates/Cadastro/Empresas/modals/Detalhes'
import DetalhesFuncionario from 'templates/Cadastro/Funcionarios/organismos/modals/Detalhes'

const Clientes = React.lazy(() => import('pages/Clientes'))
const UsuariosPage = React.lazy(() => import('pages/Usuarios'))
const Certificados = React.lazy(() => import('pages/Certificados'))
const EmpresasClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/Empresas'),
)

const RegistrosEmpresaCliente = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/RegsitrosEmpresas'),
)

const UsuariosClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/Usuarios'),
)

const ModulosClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/Modulo'),
)

const CobrancasClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/Cobrancas'),
)

const CredenciaisApiClientePage = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/CredenciaisApi'),
)

const EditarCredencialApiCliente = React.lazy(
    () => import('@/templates/Admin/Clientes/modals/EditarCredencialApi'),
)

const TrocasInicioPontoEmpresa = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/TrocaInicioPonto'),
)
const AdicionarTrocaInicioPonto = React.lazy(
    () =>
        import(
            '@/templates/Admin/Clientes/atoms/Pages/AdicionarTrocaInicioPonto'
        ),
)
const FuncionariosEmpresaCliente = React.lazy(
    () => import('@/templates/Admin/Clientes/atoms/Pages/FuncionariosEmpresas'),
)
const PlanosPrecos = React.lazy(() => import('pages/PlanosPrecos'))

const base = '/administracao'
const clientes = '/clientes'
const clienteId = '/clientes/:clienteId'
const usuarios = '/usuarios'
const usuarioId = '/usuarios/:usuarioId'
const empresas = '/empresas'
const empresaId = '/empresas/:empresaId'
const registros = '/registros'
const registroId = '/registros/:registroId'
const funcionarios = '/funcionarios'
const funcionarioId = '/funcionarios/:funcionarioId'
const certificados = '/certificados'
const certificadoId = '/certificados/:certificadoId'
const cobrancas = '/cobrancas'
const treinamentoId = '/cobrancas/:treinamentoId'
const planosPrecos = '/planos-precos'
const planoId = '/planos-precos/:planoId'
const modulos = '/modulos'
const trocaInicioPonto = '/troca-inicio-ponto'
const integracaoApi = '/integracao-api'

const AdminPreloader = () => {
    const [searchParams] = useSearchParams()
    const filter = searchParams.get('filter')

    const { data } = clientesApi.useFetch<PaginatedResponse<Cliente>>({
        queryParams: filter ? { filter } : undefined,
        enabled: true,
    })

    return <Outlet context={{ clientes: data?.data }} />
}

export function useAdminOutletContext() {
    return useOutletContext<{ clientes?: Cliente[] }>()
}

export const admin: RouteObject = {
    path: base,
    element: <AdminPreloader />,
    children: [
        {
            // url: /administracao/clientes
            path: base + clientes,
            element: <Clientes />,
            children: [
                {
                    path: base + clientes + '/adicionar',
                    element: <AdicionarClientes />,
                },
                {
                    path: base + clienteId + '/editar',
                    element: <EditarCliente />,
                },
                {
                    path: base + clienteId + '/financeiro',
                    element: <FinanceiroCliente />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:clienteId/usuarios
            path: base + clienteId + usuarios,
            element: <UsuariosClientePage />,
            children: [
                {
                    path: base + clienteId + usuarioId + '/alterar-senha',
                    element: <AdminAlterarSenha />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:clienteId/modulos
            path: base + clienteId + modulos,
            element: <ModulosClientePage />,
        },
        {
            // url: /administracao/clientes/:id/integracao-api
            path: base + clienteId + integracaoApi,
            element: <CredenciaisApiClientePage />,
            children: [
                {
                    path:
                        base +
                        clienteId +
                        integracaoApi +
                        '/:credencialId/editar',
                    element: <EditarCredencialApiCliente />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:clienteId/cobrancas
            path: base + clienteId + cobrancas,
            element: <CobrancasClientePage />,
            children: [
                {
                    path: base + clienteId + cobrancas + '/adicionar',
                    element: <AdicionarTreinamento />,
                },
                {
                    path: base + clienteId + treinamentoId + '/editar',
                    element: <EditarTreinamento />,
                },
                {
                    path: base + clienteId + treinamentoId + '/excluir',
                    element: <ExcluirTreinamento />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:clienteId/empresas
            path: base + clienteId + empresas,
            element: <EmpresasClientePage />,
            children: [
                {
                    path: base + clienteId + empresaId + '/detalhes',
                    element: <DetalhesEmpresa />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:clienteId/empresas/:empresaId/troca-inicio-ponto
            path: base + clienteId + empresaId + trocaInicioPonto,
            element: <TrocasInicioPontoEmpresa />,
            children: [
                {
                    path:
                        base +
                        clienteId +
                        empresaId +
                        trocaInicioPonto +
                        '/adicionar',
                    element: <AdicionarTrocaInicioPonto />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:clienteId/empresas/:empresaId/registros
            path: base + clienteId + empresaId + registros,
            element: <RegistrosEmpresaCliente />,
            children: [
                {
                    path:
                        base + clienteId + empresaId + registroId + '/detalhes',
                    element: <DetalhesRegistro />,
                },
            ],
        },
        {
            // url: /administracao/clientes/:clienteId/empresas/:empresaId/funcionarios
            path: base + clienteId + empresaId + funcionarios,
            element: <FuncionariosEmpresaCliente />,
            children: [
                {
                    path:
                        base +
                        clienteId +
                        empresaId +
                        funcionarioId +
                        '/detalhes',
                    element: <DetalhesFuncionario />,
                },
            ],
        },
        {
            // url: /administracao/usuarios
            path: base + usuarios,
            element: <UsuariosPage />,
            children: [
                {
                    path: base + usuarios + '/adicionar',
                    element: <AdicionarUsuario />,
                },
                {
                    path: base + usuarioId + '/editar',
                    element: <EditarUsuario />,
                },
            ],
        },
        {
            // url: /administracao/certificados
            path: base + certificados,
            element: <Certificados />,
            children: [
                {
                    path: base + certificados + '/adicionar',
                    element: <AdicionarCertificado />,
                },
                {
                    path: base + certificadoId + '/excluir',
                    element: <ExcluirCertificado />,
                },
            ],
        },
        {
            // url: /administracao/planos-precos
            path: base + planosPrecos,
            element: <PlanosPrecos />,
            children: [
                {
                    path: base + planosPrecos + '/adicionar',
                    element: <AdicionarPlano />,
                },
                {
                    path: base + planoId + '/editar',
                    element: <EditarPlano />,
                },
                {
                    path: base + planoId + '/excluir',
                    element: <ExcluirPlano />,
                },
                {
                    path: base + planosPrecos + '/importar',
                    element: <ImportarPlano />,
                },
            ],
        },
    ],
}
